import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { CustomAccordion, Text } from '../../shared/uiComponents';
import { Loader, InfoRow as Row } from '../StyledComponents';

import { DispatchProperties, useSelector } from '../../redux/store';
import { getClinicalSupervisorsBCBAs } from '../../redux/State/userSlice';

const BCBAList = ({ userId }: { userId: string }) => {
	const dispatch = useDispatch<DispatchProperties>();

	const bcbas = useSelector((state) => state.clinicalSupervisor.clinicalSupervisorsBcbas);
	const loading = useSelector((state) => state.clinicalSupervisor.loading);

	useEffect(() => {
		if (!userId) return;
		dispatch(getClinicalSupervisorsBCBAs(userId));
	}, [dispatch, userId]);

	return (
		<CustomAccordion
			headerStyle={{ padding: 0 }}
			HeaderContent={() => (
				<Row>
					<Text title="BCBAs Assigned: " type="psm" fontWeight="semiBold" />
					<Text title={`${bcbas?.length ? bcbas.length : 0}`} type="psm" />
				</Row>
			)}
			Content={() => (
				<div style={{ padding: '0px 8px' }}>
					{bcbas?.length ? (
						<>
							{bcbas.map((user, index) => (
								<Text key={index} title={`${index + 1}. ${user.fullName}`} type="psm" />
							))}
						</>
					) : (
						<Text title="None" type="psm" />
					)}
					{loading && <Loader />}
				</div>
			)}
		/>
	);
};

export default BCBAList;
